<template>
    <div>
        <template v-if="false">
            <LoadCssComponent :estilos="configuracion.css_front"/>
        </template>

        <HeaderComponent/>

        <transition name="fade" mode="out-in">
            <main id="main">
                <router-view/>
            </main>
        </transition>
        <FooterComponent/>
    </div>    
</template>

<script>
    import HeaderComponent from '@/components/frontend/header/HeaderComponent';
    import FooterComponent from '@/components/frontend/footer/FooterComponent';
    import LoadCssComponent from  '@/components/css/LoadCssComponent';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        data() {
            return {

            }
        },
        created() {
            useHead('FrontEnd');
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        components: {
            HeaderComponent, FooterComponent, LoadCssComponent
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>